import { render } from "./ListadoEnviados.vue?vue&type=template&id=78625084"
import script from "./ListadoEnviados.vue?vue&type=script&lang=js"
export * from "./ListadoEnviados.vue?vue&type=script&lang=js"

import "./ListadoEnviados.vue?vue&type=style&index=0&id=78625084&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__